var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1798 13.6779C15.8672 13.9904 15.4433 14.166 15.0012 14.166H1.6668C1.22474 14.166 0.80078 13.9904 0.488194 13.6779C0.175609 13.3653 0 12.9414 0 12.4994V1.66659C0 1.22458 0.175609 0.800678 0.488194 0.488132C0.80078 0.175586 1.22474 0 1.6668 0H4.94206C5.21801 4.54324e-05 5.48962 0.0685916 5.73254 0.199488C5.97546 0.330384 6.18207 0.519534 6.33384 0.749965L7.00889 1.74992C7.16221 1.98272 7.37147 2.17335 7.61753 2.30437C7.86358 2.4354 8.13858 2.50262 8.41734 2.49988H15.0012C15.4433 2.49988 15.8672 2.67547 16.1798 2.98801C16.4924 3.30056 16.668 3.72446 16.668 4.16647V12.4994C16.668 12.9414 16.4924 13.3653 16.1798 13.6779Z",
    stroke: "#151B26",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.668,
    height: 14.166,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.ec25a2ddcb5361847c38c1e8b47de14a.svg";
export { ForwardRef as ReactComponent };